export default "__VITE_ASSET__CE$Ffohj__"